module.exports = __webpack_public_path__ + "img/hero1.7de4564d.png";